export const mediaIcon = (fileName: string): string => {
    const parts = fileName.split('.');
    const extension =
        parts.length > 1 ? (parts.pop()?.toLowerCase() as string) : '';

    const exactMatches: Record<string, string> = {
        jpg: 'fa-file-jpg',
        jpeg: 'fa-file-jpg',
        jpe: 'fa-file-jpg',
        png: 'fa-file-png',
        pdf: 'fa-file-pdf',
        doc: 'fa-file-doc',
        docx: 'fa-file-doc',
        ppt: 'fa-file-ppt',
        pptx: 'fa-file-ppt',
        xls: 'fa-file-xls',
        xlsx: 'fa-file-xls',
        csv: 'fa-file-csv',
        txt: 'fa-file-lines',
        rtf: 'fa-file-lines',
        mp3: 'fa-file-mp3',
        mp4: 'fa-file-mp4',
    };

    if (exactMatches[extension]) return exactMatches[extension];

    const imageExts = ['gif', 'bmp', 'tiff', 'tif'];
    const audioExts = ['aac', 'amr', '3ga', 'ogg'];
    const videoExts = ['m4v', '3gp', '3g2'];

    if (imageExts.includes(extension)) return 'fa-file-image';
    if (audioExts.includes(extension)) return 'fa-file-audio';
    if (videoExts.includes(extension)) return 'fa-file-video';

    return 'fa-file';
};
